const RewardsFormView = () => import('./views/RewardsFormView');
const RewardsBankFormView = () => import('./views/RewardsBankFormView');
const RewardsView = () => import('./views/RewardsView');
const RankingView = () => import('@/gamification/views/RankingView');
const BadgesView = () => import('@/gamification/views/BadgesView');
const RateView = () => import('@/gamification/views/RateView');
const CoinsUpdaterView = () => import('@/gamification/views/CoinsUpdaterView');
const Coins = () => import('@/gamification/views/CoinsView');

const routes = [
  {
    path: '/rewards',
    name: 'rewards',
    component: RewardsView,
  },
  {
    path: '/new-reward',
    name: 'rewards-form',
    component: RewardsFormView,
  },
  {
    path: '/rewards-bank',
    name: 'rewards-bank',
    component: RewardsBankFormView,
  },
  {
    path: '/ranking',
    name: 'ranking',
    component: RankingView,
  },
  {
    path: '/badges',
    name: 'badges',
    component: BadgesView,
  },
  {
    path: '/rate',
    name: 'rate',
    component: RateView,
  },
  {
    path: '/coins-updater',
    name: 'coins-updater',
    component: CoinsUpdaterView,
  },
  {
    path: '/allow-coins',
    name: 'allow-coins',
    component: Coins,
  },
];

export default (router) => {
  routes.forEach((element) => {
    router.addRoute('main', element);
  });
};
